<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.29289 2.29289C4.90237 2.68342 4.90237 3.31658 5.29289 3.70711L9.58579 8L5.29289 12.2929C4.90237 12.6834 4.90237 13.3166 5.29289 13.7071C5.68342 14.0976 6.31658 14.0976 6.70711 13.7071L11.7071 8.70711C12.0976 8.31658 12.0976 7.68342 11.7071 7.29289L6.70711 2.29289C6.31658 1.90237 5.68342 1.90237 5.29289 2.29289Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'DisclosureSmallIcon',
  props: {
    width: {
      type: Number,
      default: 16,
    },
    height: {
      type: Number,
      default: 16,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
